import axios from 'axios';

export async function getSystemHosts(host: string) {
  const response = await axios.get(`https://${host}/system-hosts`);
  return response.data;
}
